import React from "react";
import PropTypes from "prop-types";

function UserLinks(props) {
  const { twitter_url, related_links } = props;

  return (
    <div id='object-link'>
      { twitter_url && (
        <a id='link-profile-twitter' target='_blank' href={twitter_url} rel='noopener noreferrer'>
          <i className='fab fa-twitter' />
        </a>
      )}

      { related_links.map((link, index) => {
        return (
          <a key={link.id} id={`link-profile-link-${index + 1}`} target='_blank' href={link.url} rel='noopener noreferrer'>
            <i className='fas fa-link' />
          </a>
        );
      })}
    </div>
  );
}

UserLinks.propTypes = {
  twitter_url: PropTypes.string,
  related_links: PropTypes.arrayOf(PropTypes.object)
};

UserLinks.defaultProps = {
  twitter_url: null,
  related_links: []
};

export default UserLinks;
